import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ICustomerAccountVisit } from '@app/customer-account/models/customer-account-visit.model';
import { IVisitCancellationRequestResult } from '@app/customer-account/models/visit-cancellation-request-result.model';
import { Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CustomerAccountVisitsService {

  constructor(private http: HttpClient) { }

  getPendingVisits(): Observable<ICustomerAccountVisit[]> {
    return this.http.get<ICustomerAccountVisit[]>(`/api/visits/pending`)
      .pipe(
        map(visits => visits.map(visit => ({
          showMore: false,
          ...visit
        })))
      );
  }

  getVisitsHistory(): Observable<ICustomerAccountVisit[]> {
    return this.http.get<ICustomerAccountVisit[]>(`/api/visits/history`)
      .pipe(
        map(visits => visits.map(visit => ({
          showMore: false,
          ...visit
        })))
      );
  }

  sendVisitCancellationRequest(visitId: string, salonId: string): Observable<IVisitCancellationRequestResult> {
    return this.http.post<IVisitCancellationRequestResult>(`/api/visits/cancel`, { visitId, salonId });
  }

}
